<div class="map-mobile-nav">
  <nav>
    <a [routerLink]="['/', searchRouteSlug]">
      <fa-icon icon="search" /><br />
      Search
    </a>
    <a [routerLink]="['/', 'mobile', 'buy-sell']">
      <fa-icon icon="gavel" /><br />
      {{ buySellTitle$ | async }}
    </a>
    <a [routerLink]="['/', 'saved-properties']">
      <fa-icon [icon]="['far', 'heart']" /><br />
      Saved
    </a>
    <a [routerLink]="['/', 'my-profile', 'alerts-notifications']"> <fa-icon [icon]="['far', 'bell']" /><br />Alerts</a>
    <a [routerLink]="['/', 'my-profile']">
      <fa-icon icon="user" /><br />
      Profile
    </a>
  </nav>
</div>
